const englishSpellingLUT: {
  us: string;
  gb: string;
}[] = [
  {
    us: "savior",
    gb: "saviour",
  },
  {
    us: "savior's",
    gb: "saviour's",
  },
];

export function applyCorrectEnglish(
  phrase: string,
  destinationCountry: string,
): string {
  const country = destinationCountry.toLowerCase();
  const isUpperCase = (word: string) => word === word.toUpperCase();
  const isCapitalized = (word: string) => word[0] === word[0].toUpperCase();

  return phrase
    .split(" ")
    .map((word) => {
      const punctuationMatch = word.match(/[.,!?]$/);
      const punctuation = punctuationMatch ? punctuationMatch[0] : ""; // Extract trailing punctuation
      const strippedWord = word.slice(0, word.length - punctuation.length); // Remove punctuation

      const match = englishSpellingLUT.find(
        (entry) =>
          (country === "us"
            ? entry.gb.toLowerCase()
            : entry.us.toLowerCase()) === strippedWord.toLowerCase(),
      );

      if (match) {
        const replacement = country === "us" ? match.us : match.gb;

        let correctedWord = replacement.toLowerCase();

        if (isUpperCase(strippedWord)) {
          correctedWord = replacement.toUpperCase();
        } else if (isCapitalized(strippedWord)) {
          correctedWord =
            replacement[0].toUpperCase() + replacement.slice(1).toLowerCase();
        }

        return correctedWord + punctuation;
      }

      return word;
    })
    .join(" ");
}
